import * as Turbo from '@hotwired/turbo'
Turbo.start()

import "../controllers"

// Font Awesome
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

// Fonts
import "@fontsource/nunito";                // 400 normal
import "@fontsource/nunito/700.css";        // 700 normal
import "@fontsource/nunito/400-italic.css"; // 400 italic
import "@fontsource/nunito/700-italic.css"; // 700 italic

import '../src/main'

import 'flowbite/dist/flowbite.turbo'

import '@/builds/tailwind.css'